import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms'

//Popup Components
import { AlertComponent } from '../../popup/alert.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { CarrierTypeDocumentService } from 'app/services/carrier-type-document.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AuthWebService } from 'app/services/authweb.service';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import {DocumenttypeService} from 'app/services/documenttype.service';
import { ToastrService } from 'ngx-toastr';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';

@Component({
  selector: 'app-carrier-type-document',
  templateUrl: './carrier-type-document.component.html',
  styleUrls: ['./carrier-type-document.component.css']
})
export class CarrierTypeDocumentComponent implements OnInit {

  form;
  vCDocType: any = {};
  carrierTypes:any =[];
  docuTypes:any=[];
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;  
  isDup = false; 
  selectedDisplay = 3;
  message = null;
  now = new Date();
  audit = { created: '', updated: '' };
  user = { LastName: '' };
  
  public isLoading = false;

  constructor(private service: CarrierTypeDocumentService,private carrierTypeService: CarrierTypeService,
    private docutypeservice: DocumenttypeService,
    private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,private toastService:ToastNotificationService,
     public utility: UtilityServiceService,private toastr: ToastrService) { }

    ngOnInit() {
      //get list of carrier types
      //console.log("Fetch Carrier Types");
      this.carrierTypeService.getAll().subscribe(result => {
        this.carrierTypes = result;
        
         }, error => {
       
      });
      //console.log(this.carrierTypes);
      //get list of document types
      //console.log("Fetch Document Types");
      
      this.docutypeservice.getAll().subscribe(result => {
        this.docuTypes = result;
                   
         }, error => {
       
      });
      //console.log(this.docuTypes);
      
      //set value to the ids that come with the object


      this.initForm();
     
      this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
      this.sub = this.route.params.subscribe(params => {
        if (this.router.url.indexOf('edit') != -1) {
          this.isEdit = true;
          this.lblHeading = 'Edit Carried Document Type';
          this.btnActionLabel = 'Update';
          const id = +params['id'];
          this.isLoading = true;
          this.service.getById(id).subscribe(result => {
            this.vCDocType = result;
            this.isLoading = false;
            (<FormGroup>this.form)
              .setValue({
                id: this.vCDocType.id
                , carrier_type_id: this.vCDocType.carrier_type_id
                , carriertype: this.vCDocType.carriertype
                , document_type_id: this.vCDocType.document_type_id
                , doctype: this.vCDocType.doctype
                , is_active: this.vCDocType.is_active
                , date_created: this.vCDocType.date_created
                , date_modified: this.vCDocType.date_modified
                , user_created: this.vCDocType.user_created
                , user_modified: this.vCDocType.user_modified
               
              }, { onlySelf: true });
            this.audit = this.utility.setAuditAttributes(this.vCDocType.date_created, this.vCDocType.user_created, this.vCDocType.date_modified, this.vCDocType.user_modified);
          });
        } else {
          this.isEdit = false;
          this.lblHeading = 'Add New';
          this.btnActionLabel = 'Save';
          this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName); 
        }
      });
    }
    initForm(){
      this.form = new FormGroup({
        id: new FormControl()
        , carrier_type_id: new FormControl(this.vCDocType.carrier_type_id, Validators.required)
        , carriertype: new FormControl(this.vCDocType.carriertype, Validators.required)
        , document_type_id: new FormControl(this.vCDocType.document_type_id, Validators.required)
        , doctype: new FormControl(this.vCDocType.doctype, Validators.required)
        , is_active: new FormControl(this.vCDocType.is_active,Validators.required)
        , date_created: new FormControl()
        , date_modified: new FormControl()
        , user_created: new FormControl()
        , user_modified: new FormControl()
        , vehicle: new FormControl()
      });
      this.form.patchValue(this.utility.defaults);

    } 
    navigate() {
      this.router.navigateByUrl('carrier/documenttype/list');
    }
    ngOnDestroy() {
      this.sub.unsubscribe();
    }
    onSelectChange(){

    }
    onSubmit(obj: any) {    
      if (this.isDup) { return; }
      this.vCDocType = obj;
      this.message = (this.isEdit) ? "Updating Carried Document Type..." : "Adding a new Carried Document Type...";
      if (this.isEdit) {
        this.vCDocType.date_modified = new Date();
        this.vCDocType.user_modified = this.user.LastName;
        this.isLoading = true;
        //console.log(JSON.stringify(obj));
        this.service.update(this.vCDocType).subscribe(result => {
          this.vCDocType = result;
          this.isLoading = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'Update Carried Document Type', message: `Carried Document Type ${this.vCDocType.carriertype} updated succesfully.`, bold: `${this.vCDocType.carriertype}` });
          this.toastService.success(`Carried Document Type ${this.vCDocType.carriertype} updated succesfully.`,'Update Carried Document Type');

          this.navigate();
        });
      } else {
        this.vCDocType.date_modified = this.vCDocType.date_created = new Date();
        this.vCDocType.user_modified = this.vCDocType.user_created = this.user.LastName;
  
        this.isLoading = true;
        //console.log(JSON.parse(JSON.stringify(obj)));
        console.dir(this.vCDocType);
        this.service.add(this.vCDocType).subscribe(result => {
          this.vCDocType = result;
          this.isLoading = false;
          // this.dialogService.addDialog(AlertComponent, { title: 'New Carried Document Type', message: `New Carried Document Type ${this.vCDocType.carriertype} added successfully.`, bold: `${this.vCDocType.carriertype}` });
          this.toastService.success(`New Carried Document Type ${this.vCDocType.carriertype} added successfully.`,'New Carried Document Type');

          this.navigate();
        });
      }
    }  
}
